import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Modal from "react-modal";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import SelectDropdown from "../../components-react/SelectDropdown";
import {
  fetchAgentsData,
  fetchCampaignDropdown,
} from "../../../redux/reducers/dropdownApiSlice";
import { addNewJob } from "../../../redux/reducers/postApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { panelTypes } from "../../common-data/DropdowData";
import MultiSelect from "../../components-react/MultiSelect";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import OTPVerify from "./verifications/OTPVerify";
import { otpRequestAPI, otpVerifyAPI } from "../../../data/ApiEndpoints";
import { commonPostPutFormData } from "../../../redux/reducers/commonApiSlice";
// import Quill from "quill";
// const Delta = Quill.import("delta");

const JobForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isReInitiate,
  selectedRows,
  closeInitiateModal,
}) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.common);
  const { allCampaigns, agents } = useSelector((state) => state.dropdown);
  // const quillRef = useRef(null);
  const timerIdRef = useRef(null);

  const allClientNumbers =
    isReInitiate && selectedRows?.length > 0
      ? selectedRows.map((num) => num?._cl).join("\n")
      : "";
  const rowData =
    isReInitiate && selectedRows?.length > 0 ? selectedRows[0] : null;

  const iniFormValues = {
    panelType:
      isReInitiate && rowData?.panel_type
        ? {
            label: rowData.panel_type === "panel_1" ? "Main" : "IVR",
            value: rowData.panel_type,
          }
        : "",
    isIVR: isReInitiate && rowData?.campaign_type === "2" ? true : false,
    isP2P: isReInitiate && rowData?.campaign_type === "1" ? true : false,
    jobName:
      isReInitiate && rowData?.job_name
        ? rowData.job_name?.replace(/_/g, " ")
        : "",
    selectedCampaign:
      isReInitiate && rowData?.campaign_name && rowData?._ivid
        ? {
            label: rowData.campaign_name?.replace(/_/g, " "),
            value: rowData._ivid,
          }
        : "",
    uploadedDoc: "",
    isCopyPaste: isReInitiate ? true : false,
    numbers: isReInitiate ? allClientNumbers : "",
    agents: [],
    distributedNumbers: [],
    parentId:
      isReInitiate && rowData?.parent_id
        ? rowData.parent_id
        : isReInitiate && rowData?.job_id
        ? rowData.job_id
        : "",
    rootId:
      isReInitiate && rowData?.root_id
        ? rowData.root_id
        : isReInitiate && rowData?.job_id
        ? rowData.job_id
        : "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const iniModValues = {
    isModOpen: false,
    otp: "",
    timerCount: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [agentsNumberCount, setAgentsNumberCount] = useState([]);

  const closeModValues = () => {
    setModValues(iniModValues);
  };

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    let processedValue = value;

    if (name === "numbers") {
      processedValue = value
        .split(/[\n\r]+/)
        .map((number) => number.trim())
        .filter(Boolean)
        .join("\n");

      setFormValues((prevs) => ({
        ...prevs,
        [name]: processedValue,
      }));
    } else if ((name === "isP2P" || name === "isIVR") && !isReInitiate) {
      setFormValues((prevs) => ({
        ...prevs,
        jobName: "",
        selectedCampaign: "",
        uploadedDoc: "",
        isCopyPaste: false,
        numbers: "",
        agents: [],
        distributedNumbers: [],
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    } else if ((name === "isP2P" || name === "isIVR") && isReInitiate) {
      setFormValues((prevs) => ({
        ...prevs,
        selectedCampaign: "",
        agents: [],
        distributedNumbers: [],
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (name, value) => {
    if (name === "panelType" && !isReInitiate) {
      setFormValues((prev) => ({
        ...prev,
        isIVR: false,
        isP2P: false,
        jobName: "",
        selectedCampaign: "",
        uploadedDoc: "",
        isCopyPaste: false,
        numbers: "",
        agents: [],
        distributedNumbers: [],
        [name]: value,
      }));
    } else if (name === "panelType" && isReInitiate) {
      setFormValues((prev) => ({
        ...prev,
        selectedCampaign: "",
        agents: [],
        [name]: value,
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // const onChangeTextInput = (content, fieldName) => {
  //   setIsSubmit(false);
  //   setFormValues((prev) => ({
  //     ...prev,
  //     [fieldName]: content,
  //   }));
  // };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    if (!formValues.jobName) {
      errors.jobName = "Job Name is required!";
    }

    if (!formValues.selectedCampaign) {
      errors.selectedCampaign = "Campaign is required!";
    }

    if (!formValues.isCopyPaste && !formValues.uploadedDoc) {
      errors.uploadedDoc = "Doc is required!";
    }

    if (formValues.isCopyPaste && !formValues.numbers) {
      errors.numbers = "Doc is required!";
    }

    if (
      formValues.isCopyPaste &&
      formValues.isP2P &&
      formValues.agents?.length === 0
    ) {
      errors.agents = "Doc is required!";
    }

    return errors;
  };

  function knowLength(numbersString) {
    if (numbersString) {
      const numbersArray = numbersString.split("\n");
      const numberOfNumbers = numbersArray.length;
      return numberOfNumbers;
    } else {
      return 0;
    }
  }

  function knowValidNumbers(allNumbers) {
    const numbersArray = allNumbers
      ? allNumbers
          ?.split("\n")
          ?.map((number) => number.trim())
          ?.filter(Boolean)
      : "";

    const validNumbers = numbersArray
      .map((number) => number?.replace(/\D/g, ""))
      .filter((number) => number?.length === 12)
      .map((number) => ({ number }));

    const validNumbersCount = validNumbers?.length;

    const invalidNumberCount = numbersArray.length - validNumbersCount;

    return validNumbersCount;

    // const validNoLength = distributedNumbers
    //   ? parseInt(distributedNumbers?.length)
    //   : 0;
    // const allNoLength = allNumbers ? parseInt(knowLength(allNumbers)) : 0;

    // const invalidNumCounts =
    //   validNoLength === 0
    //     ? distributeNumbersIvr(numbersArray)
    //     : allNoLength - validNoLength;
    // return invalidNumCounts;
  }

  function knowInvalidNumbers(allNumbers) {
    const numbersArray = allNumbers
      ? allNumbers
          ?.split("\n")
          ?.map((number) => number.trim())
          ?.filter(Boolean)
      : "";

    const validNumbers = numbersArray
      .map((number) => number?.replace(/\D/g, ""))
      .filter((number) => number?.length === 12)
      .map((number) => ({ number }));

    const validNumbersCount = validNumbers?.length;

    const invalidNumberCount = numbersArray.length - validNumbersCount;

    return invalidNumberCount;
  }

  const handleAdd = async (requestBody) => {
    const TOKEN = userInfoData?.token || "";

    try {
      const result = await dispatch(addNewJob({ requestBody, TOKEN }));

      console.log(result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setIsSubmit(false);
        closeModal();
        closeInitiateModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  function getNumberCountsAgentWise() {
    // const allAgent = agents.filter((agent) => agent?.value);
    // console.log("allAgent=> ", allAgent);
  }

  function getAgents(filter) {
    dispatch(
      fetchAgentsData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  function getCampaigns(filters) {
    dispatch(
      fetchCampaignDropdown({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const distributeNumbers = (numbers, agents) => {
    const numAgents = agents?.length;
    const cleanedNumbers = numbers
      .map((number) => number?.replace(/\D/g, ""))
      .filter((number) => number?.length === 12);

    const distributedNumbers = cleanedNumbers?.map((number, index) => {
      const agentIndex = index % numAgents;
      const agent = agents[agentIndex];
      return {
        number,
        user_id: agent?.value,
      };
    });

    return distributedNumbers;
  };

  const distributeNumbersIvr = (numbers) => {
    const cleanedNumbers = numbers
      .map((number) => number?.replace(/\D/g, ""))
      .filter((number) => number?.length === 12)
      .map((number) => ({ number }));

    return cleanedNumbers;
  };

  function matchAndCount(distributedNumbers, agents) {
    const userMap = new Map();

    distributedNumbers.forEach((numberObj) => {
      const userId = numberObj?.user_id;

      const agent = agents.find((agent) => agent?.value === userId);

      if (agent) {
        const name = agent?.info?.name;

        if (userMap.has(userId)) {
          userMap.get(userId).count += 1;
        } else {
          userMap.set(userId, { name: name, count: 1 });
        }
      }
    });

    const resultArray = Array.from(userMap, ([user_id, { name, count }]) => ({
      user_id,
      name,
      count,
    }));

    return resultArray;
  }

  const startTimer = () => {
    setModValues((prevs) => ({ ...prevs, timerCount: 120 }));

    if (timerIdRef.current) {
      clearInterval(timerIdRef.current);
    }

    timerIdRef.current = setInterval(() => {
      setModValues((prevs) => {
        if (prevs.timerCount > 0) {
          return { ...prevs, timerCount: prevs.timerCount - 1 };
        } else {
          clearInterval(timerIdRef.current);
          return prevs;
        }
      });
    }, 1000);
  };

  const handleVertfyOTP = async (requestBody, apiEndoint, callFor) => {
    const method = "POST";
    const endpoint = apiEndoint;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");

        if (callFor === "request-otp") {
          startTimer();
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            requestNumber: userInfoData?.mobile,
          }));
        } else if (callFor === "verify-otp") {
          const handleConfirm = async () => {
            const formData = new FormData();
            formData.append("job_name", formValues.jobName);
            formData.append("campaign_id", formValues.selectedCampaign?.value);
            formData.append("file", formValues.uploadedDoc);
            formData.append(
              "obd_data",
              JSON.stringify(formValues.distributedNumbers)
            );
            formData.append("parent_job_id", formValues.parentId);
            formData.append("root_job_id", formValues.rootId);

            handleAdd(formData);
          };

          showConfirmAlert(
            handleConfirm,
            `Number Is Verified, Do You Want To Proceed!`
          );

          closeModValues();
        }
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  // const insertFormattedData = (formattedData) => {
  //   if (quillRef.current) {
  //     const quill = quillRef.current.getEditor();
  //     const range = quill.getSelection(true);
  //     quill.clipboard.dangerouslyPasteHTML(range.index, formattedData);
  //   }
  // };

  // const handlePaste = (event) => {
  //   event.preventDefault();
  //   const clipboardData = event.clipboardData || window.clipboardData;
  //   const pastedData = clipboardData.getData("Text");
  //   const formattedData = pastedData
  //     .split("\n")
  //     .map((line) => `<p>${line}</p>`)
  //     .join("");
  //   insertFormattedData(formattedData);
  // };

  useEffect(() => {
    if ((formValues.isP2P || formValues.isIVR) && formValues.panelType) {
      const filters = {
        campaign_type:
          formValues.isP2P && formValues.isIVR
            ? ""
            : formValues.isP2P
            ? "1"
            : formValues.isIVR
            ? "2"
            : "",
        plan_type: formValues.panelType?.value || "",
      };

      getCampaigns(filters);
    }
  }, [formValues.isP2P, formValues.isIVR, formValues.panelType]);

  useEffect(() => {
    if (formValues.panelType?.value === "panel_1" && formValues.isP2P) {
      const filters = {
        page: 1,
        page_size: 300,
        is_mapped: 1,
        panel_type: formValues.panelType?.value || "",
      };

      getAgents(filters);
    }
  }, [formValues.panelType, formValues.isP2P]);

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      isP2P: formValues.isIVR ? false : prevs.isP2P,
      isIVR: formValues.isP2P ? false : prevs.isIVR,
    }));
  }, [formValues.isP2P, formValues.isIVR]);

  useEffect(() => {
    if (
      formValues.isP2P &&
      formValues.numbers &&
      formValues.agents?.length > 0
    ) {
      const numbersArray = formValues.numbers
        ?.split("\n")
        ?.map((number) => number.trim())
        ?.filter(Boolean);

      const distributedNumbers = distributeNumbers(
        numbersArray,
        formValues.agents
      );

      setFormValues((prev) => ({
        ...prev,
        distributedNumbers,
      }));
    } else if (formValues.isIVR && formValues.numbers) {
      const numbersArray = formValues.numbers
        ?.split("\n")
        ?.map((number) => number.trim())
        ?.filter(Boolean);

      const distributedNumbers = distributeNumbersIvr(
        numbersArray,
        formValues.agents
      );

      setFormValues((prev) => ({
        ...prev,
        distributedNumbers,
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        distributedNumbers: [],
      }));
    }
  }, [
    formValues.numbers,
    formValues.agents,
    formValues.isP2P,
    formValues.isIVR,
  ]);

  useEffect(() => {
    if (formValues.distributedNumbers?.length > 0) {
      getNumberCountsAgentWise();
    }
  }, [formValues.distributedNumbers]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const handleConfirm = async () => {
        const formData = new FormData();
        formData.append("mobile", userInfoData?.mobile);

        handleVertfyOTP(formData, otpRequestAPI, "request-otp");
      };

      showConfirmAlert(
        handleConfirm,
        `${userInfoData?.mobile} Number Is Correct?`
      );
    }
  }, [isSubmit, formErrors]);

  useEffect(() => {
    return () => {
      if (timerIdRef.current) {
        clearInterval(timerIdRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (formValues.distributedNumbers?.length > 0 && agents?.length > 0) {
      const result = matchAndCount(formValues.distributedNumbers, agents);
      setAgentsNumberCount(result);
    } else {
      setAgentsNumberCount([]);
    }
  }, [formValues.distributedNumbers, agents]);

  const tbColumns = [
    {
      dataField: "name",
      text: "Agent",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
        // const agent = agents?.find((agent) => agent?.value === row?.user_id);
        // return <span className="tb-data">{agent?.label || "NA"}</span>;
      },
    },
    {
      dataField: "count",
      text: "Count",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.count || 0}</span>;
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModValues}
        contentLabel="OTP Verification Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer timer-modal">
          <ModalHeadAndClose
            title={`Verify - OTP Sent To ${userInfoData?.mobile}`}
            onClose={closeModValues}
          />

          <OTPVerify
            userInfoData={userInfoData}
            modValues={modValues}
            setModValues={setModValues}
            onClickResend={() => {
              const formData = new FormData();
              formData.append("mobile", userInfoData?.mobile);
              handleVertfyOTP(formData, otpRequestAPI, "request-otp");
            }}
            onClickSubmit={() => {
              const formData = new FormData();
              formData.append("mobile", userInfoData?.mobile);
              formData.append("otp", modValues.otp);
              handleVertfyOTP(formData, otpVerifyAPI, "verify-otp");
            }}
          />
        </div>
      </Modal>

      <div className="form-container add-new-job">
        <form className="formContainer">
          <div className="formInputsGrid twoGridSystem">
            <div className="formInputBox">
              <label htmlFor="panelType" className={`formInputLabel `}>
                Panel Type <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.panelType ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={panelTypes}
                  selectedOption={formValues.panelType}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("panelType", selectedValue)
                  }
                  name="Panel Type"
                />
              </div>
            </div>
          </div>

          {isReInitiate || formValues.panelType ? (
            <div className={`commonWrapper switchs-input-container`}>
              <Form.Check
                type="switch"
                name="isP2P"
                className={`${formErrors?.isP2P ? "formError" : ""}`}
                label={`${formValues.isP2P ? "P2P" : "P2P Inactive"}`}
                checked={formValues.isP2P}
                onChange={onChangeInput}
              />

              <Form.Check
                type="switch"
                name="isIVR"
                className={`${formErrors?.isIVR ? "formError" : ""}`}
                label={`${formValues.isIVR ? "IVR" : "IVR Inactive"}`}
                checked={formValues.isIVR}
                onChange={onChangeInput}
              />

              {formValues.campaignType?.value === "1" ? (
                <Form.Check
                  type="switch"
                  name="isAgentMissed"
                  className={`${formErrors?.isAgentMissed ? "formError" : ""}`}
                  label={`${
                    formValues.isAgentMissed
                      ? "Agent Missed"
                      : "No Agent Missed"
                  }`}
                  checked={formValues.isAgentMissed}
                  onChange={onChangeInput}
                />
              ) : formValues.campaignType?.value === "2" ? (
                <Form.Check
                  type="switch"
                  name="isUserMissed"
                  className={`${formErrors?.isUserMissed ? "formError" : ""}`}
                  label={`${
                    formValues.isUserMissed ? "User Missed" : "No User Missed"
                  }`}
                  checked={formValues.isUserMissed}
                  onChange={onChangeInput}
                />
              ) : null}
            </div>
          ) : null}

          {isReInitiate ? (
            <div className="formInputsGrid twoGridSystem">
              <div className="formInputBox">
                <label htmlFor="parentId" className={`formInputLabel `}>
                  Parent ID
                </label>

                <input
                  type="text"
                  className="formInput"
                  name="parentId"
                  placeholder={`🚫 ${formValues.parentId || "NA"}`}
                  disabled
                />
                {/* <input
                  type="text"
                  placeholder="Enter JOB Name"
                  className={`formInput ${
                    formErrors?.parentId ? "formError" : ""
                  }`}
                  name="parentId"
                  value={formValues.parentId}
                  onChange={onChangeInput}
                /> */}
              </div>

              <div className="formInputBox">
                <label htmlFor="rootId" className={`formInputLabel `}>
                  Root ID
                </label>

                <input
                  type="text"
                  className="formInput"
                  name="rootId"
                  placeholder={`🚫 ${formValues.rootId || "NA"}`}
                  disabled
                />
                {/* <input
                  type="text"
                  placeholder="Enter JOB Name"
                  className={`formInput ${
                    formErrors?.parentId ? "formError" : ""
                  }`}
                  name="parentId"
                  value={formValues.parentId}
                  onChange={onChangeInput}
                /> */}
              </div>
            </div>
          ) : null}

          {formValues.isP2P || formValues.isIVR ? (
            <>
              <div className="formInputsGrid twoGridSystem mt30">
                <div className="formInputBox">
                  <label htmlFor="jobName" className={`formInputLabel `}>
                    JOB Name <span className="required">*</span>
                  </label>

                  <input
                    type="text"
                    placeholder="Enter JOB Name"
                    className={`formInput ${
                      formErrors?.jobName ? "formError" : ""
                    }`}
                    name="jobName"
                    value={formValues.jobName}
                    onChange={onChangeInput}
                  />
                </div>

                <div className="formInputBox">
                  <label
                    htmlFor="selectedCampaign"
                    className={`formInputLabel `}
                  >
                    Campaign For Uploading Jobs{" "}
                    <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedCampaign && "formError"
                    }`}
                  >
                    <SelectDropdown
                      options={allCampaigns}
                      selectedOption={formValues.selectedCampaign}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown("selectedCampaign", selectedValue)
                      }
                      name="Campaign"
                    />
                  </div>
                </div>

                {/* <div className="formInputBox">
                <label htmlFor="selectedCampaign" className={`formInputLabel `}>
                  Campaign For Uploading Jobs(Only .csv and .xlsx file types are
                  supported) *
                </label>

                <div
                  className={`commonWrapper switchs-input-container`}
                  style={{ height: "auto" }}
                >
                  <div
                    className={`input-group file-upload-input ${
                      formErrors?.uploadedDoc ? "formError" : ""
                    }`}
                    style={{ height: "auto" }}
                  >
                    <div className="custom-file">
                      <div className="choosefileBtn">
                        <input
                          type="file"
                          className="custom-file-input"
                          id="uploadedDoc"
                          name="uploadedDoc"
                          aria-describedby="inputGroupFileAddon01"
                          accept=".csv, .xlsx"
                          file={formValues.uploadedDoc}
                          onChange={onChangeInput}
                        />
                      </div>
                      <label
                        className="custom-file-label"
                        htmlFor="uploadedDoc"
                      >
                        Upload File
                      </label>
                    </div>
                  </div>
                </div>
              </div> */}
              </div>

              <div className={`commonWrapper switchs-input-container`}>
                <Form.Check
                  type="switch"
                  name="isCopyPaste"
                  className={`${formErrors?.isCopyPaste ? "formError" : ""}`}
                  style={{ cursor: isReInitiate ? "not-allowed" : "pointer" }}
                  label={`${
                    formValues.isCopyPaste ? "Upload FIle" : "Copy Paste Number"
                  }`}
                  checked={formValues.isCopyPaste}
                  onChange={onChangeInput}
                  disabled={isReInitiate}
                />
              </div>

              <div className="formInputsGrid twoGridSystem">
                {formValues.isCopyPaste ? (
                  <>
                    <div className="formInputBox span2">
                      <label
                        htmlFor="numbers"
                        className={`formInputLabel multi-lebel`}
                      >
                        Paste Number <span className="required">*</span>
                        {
                          // formValues.distributedNumbers?.length > 0 &&
                          formValues.numbers &&
                          parseInt(knowLength(formValues.numbers)) > 0 ? (
                            <>
                              <span className="valid-info">
                                Valid Numbers -{" "}
                                <b>
                                  {knowValidNumbers(formValues.numbers)}
                                  {/* {formValues.distributedNumbers?.length || 0} */}
                                </b>
                              </span>
                              <span className="invalid-info">
                                Invalid Numbers -{" "}
                                <b>
                                  {knowInvalidNumbers(formValues.numbers)}
                                  {/* {knowDifference(formValues.numbers)} */}
                                </b>
                              </span>
                            </>
                          ) : null
                        }
                      </label>

                      {/* <div
                      className={`commonWrapper textAreaCommonWrapper text-quill ${
                        formErrors?.numbers ? "formError" : ""
                      }`}
                    >
                      <ReactQuill
                        ref={quillRef}
                        id="numbers"
                        name="numbers"
                        className={`formInput ${
                          formErrors?.numbers ? "formError" : ""
                        }`}
                        placeholder="Enter Plan numbers"
                        value={formValues.numbers}
                        onChange={(content) =>
                          onChangeTextInput(content, "numbers")
                        }
                      />
                    </div> */}

                      <textarea
                        name="numbers"
                        className={`formInput ${
                          formErrors.numbers ? "formError" : ""
                        }`}
                        style={{
                          cursor: isReInitiate ? "not-allowed" : "pointer",
                        }}
                        placeholder="Enter Customer Number"
                        value={formValues.numbers}
                        onChange={onChangeInput}
                        disabled={isReInitiate}
                      ></textarea>
                    </div>

                    {formValues.isP2P ? (
                      <div
                        className={`formInputBox ${
                          formErrors.agents ? "formError" : ""
                        }`}
                      >
                        <label htmlFor="agents" className={`formInputLabel `}>
                          Agent <span className="required">*</span>
                        </label>

                        <div
                          className={`commonWrapper no-border multi-select-dropdown with-list`}
                        >
                          <MultiSelect
                            options={agents || []}
                            state={formValues.agents}
                            setState={(selectedValue) => {
                              setFormValues((prevs) => ({
                                ...prevs,
                                // distributedNumbers: [],
                                agents: selectedValue,
                              }));
                            }}
                            name="Agent"
                            // preventKeyboardOpen={true}
                            isShowList={true}
                          />
                        </div>
                      </div>
                    ) : null}
                  </>
                ) : (
                  <div className="formInputBox span2">
                    <label
                      htmlFor="selectedCampaign"
                      className={`formInputLabel `}
                    >
                      Campaign For Uploading Jobs(Only .csv and .xlsx file types
                      are supported) <span className="required">*</span>
                    </label>

                    <div
                      className={`commonWrapper switchs-input-container`}
                      style={{ height: "auto" }}
                    >
                      <div
                        className={`input-group file-upload-input ${
                          formErrors?.uploadedDoc ? "formError" : ""
                        }`}
                        style={{ height: "auto" }}
                      >
                        <div className="custom-file">
                          <div className="choosefileBtn">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="uploadedDoc"
                              name="uploadedDoc"
                              aria-describedby="inputGroupFileAddon01"
                              accept=".csv, .xlsx"
                              file={formValues.uploadedDoc}
                              onChange={onChangeInput}
                            />
                          </div>
                          <label
                            className="custom-file-label"
                            htmlFor="uploadedDoc"
                          >
                            Upload File
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {formValues.isP2P && agentsNumberCount?.length > 0 ? (
                <div className="overflowAuto separatedTable job-form-table mt15">
                  <PaymentLinkTable
                    tableData={agentsNumberCount || []}
                    tableColumns={tbColumns}
                  />
                </div>
              ) : null}

              <div
                className="formButtons"
                style={{ justifyContent: "flex-end" }}
              >
                <Button
                  className="saveBtn"
                  variant="danger"
                  onClick={onSumitForm}
                >
                  {loading ? <ReactVortoxSpinner /> : "Request OTP"}
                </Button>
              </div>
            </>
          ) : null}
        </form>
      </div>
    </>
  );
};

export default JobForm;
